import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectOfferSelector = state =>
  state.get('offerDetailsSelector', initialState);

const makeSelectOfferSelector = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('offer'),
  );
const makeSelectDisplayOffers = () =>
  createSelector(selectOfferSelector, offerSelectorState =>
    offerSelectorState.get('display'),
  );

export { selectOfferSelector, makeSelectOfferSelector, makeSelectDisplayOffers };
